/**
 * Defines the supported card types for cards on file and their display names.
 */
export enum CardTypeEnum {
    Visa = 'visa',
    Mastercard = 'mastercard',
    Amex = 'amex',
}

/**
 * A mapping of card types to their user-friendly display names.
 * This can be used to display the card type in the UI based on the card type value.
 */
export const CardTypeLabelMapping: Record<CardTypeEnum, string> = {
    [CardTypeEnum.Visa]: 'Visa',
    [CardTypeEnum.Mastercard]: 'Mastercard',
    [CardTypeEnum.Amex]: 'American Express',
};
